import { combineReducers } from "redux";
import storage from "redux-persist/lib/storage";

import alertReducer from "@/redux/reducers/alert";
import clientsReducer from "@/redux/reducers/clients";
import distributionsReducer from "@/redux/reducers/distributions";
import driveLinksReducer from "@/redux/reducers/drive-links";
import driveManagementReducer from "@/redux/reducers/drive-management";
import filtersReducer from "@/redux/reducers/filters";
import loadingReducer from "@/redux/reducers/loading";
import networkReducer from "@/redux/reducers/network";
import releasesReducer from "@/redux/reducers/releases";
import revenueReportsReducer from "@/redux/reducers/revenue-reports";
import searchReducer from "@/redux/reducers/search";
import selectionsReducer from "@/redux/reducers/selections";
import sendingReducer from "@/redux/reducers/sending";
import sidebarActiveTabReducer from "@/redux/reducers/sidebar-active-tab";
import tracksReducer from "@/redux/reducers/tracks";

export const initialState = {
    key: "root",
    storage,
    whitelist: [],
};

export const rootReducer = combineReducers({
    alertReducer,
    clientsReducer,
    distributionsReducer,
    driveLinksReducer,
    driveManagementReducer,
    filtersReducer,
    loadingReducer,
    networkReducer,
    releasesReducer,
    revenueReportsReducer,
    searchReducer,
    selectionsReducer,
    sendingReducer,
    sidebarActiveTabReducer,
    tracksReducer,
});
